
import Swiper from 'swiper/bundle';
import pageAccordion from './modules/dropdown.js'
document.addEventListener('DOMContentLoaded', () => {
  pageAccordion();
  const swiperRooms = new Swiper(".rooms-swiper", {
    loop: true,
    slidesPerView: 1,
    speed: 1000,
    autoplay: {
      delay: 3000,
      disableOnInteraction: false,
    },
    pagination: {
      el: ".swiper-pagination_rooms",
      clickable: true,
    },
    breakpoints: {
      0: {
        slidesPerView: 1.2,
        spaceBetween: 10

      },
      768: {
        slidesPerView: 1,
        spaceBetween: 20

      },
    },
  });



});

